<div fxLayout="column" style="margin-top: 45px;">
  <form novalidate (submit)="changePassword()" #f="ngForm" fxLayout="row" fxLayoutAlign="center" fxFlexOffset="56px">
    <mat-card fxLayout="column" fxFlex.gt-sm="400px" fxFlex.lt-sm="300px" style="
    background: #ffffff; border: 1px solid rgb(191, 191, 191); box-shadow: rgba(119, 178, 31, 0) 0px 1px 6px 1px; padding: 30px; border-radius: 15px;">
       <mat-card-header style="align-items: center;justify-content: center;padding-right: inherit;">
        <img style="width:100px; height: 100px;" src="../../../assets/img/Clamor.jpg" alt="">
        <!-- <img fxFlex="50px" src="../../../assets/icons/logohd.svg" alt=""> CUSTOMIZATION-SOLE24ORE -->
    </mat-card-header>
        <div fxLayout="column">
          <!-- <mat-card-title fxFlexOffset="3px">App24</mat-card-title> -->
          <!-- <mat-card-title fxFlexOffset="3px">Il Sole 24 ORE</mat-card-title> CUSTOMIZATION-SOLE24ORE -->
          <mat-card-subtitle class="py-1" style="text-align: center;">
            (Versione {{version}})</mat-card-subtitle>
        </div>
      <mat-card-content fxLayout="column" class="card-content">
        <span fxFlexOffset="16px"
          style="font-size: 18px; font-weight: 500">{{'Multilang.newPasswordTitle' | translate}}:</span>
        <!-- <span fxFlexOffset="16px"
          style="font-style: italic; font-family: serif">{{'Multilang.newPasswordLabel' | translate}}</span> -->
        <div fxFlexOffset="4px" class="ml-2 mb-2">
          <span
          style="font-size: 18px; font-weight: 500"><small>La password deve contere almeno:</small>
          </span>
          <ul>
            <li>8 caratteri</li>
            <li>una lettera maiuscola</li>
            <li>una lettra minuscola</li>
            <li>un numero</li>
          </ul>
        </div>

       <!-- Password old -->
       <div class="textbox mb-4">
        <i class="fa fa-lock" aria-hidden="true"></i>
        <input matInput type="password" #passOld [type]="visible ? 'text' : 'password'" required
          placeholder="{{'Multilang.passwordOld' | translate}}"
          [(ngModel)]="passwordOld" name="passwordOld">
      </div>

    <!-- Password1 -->
    <div class="textbox mb-4">
      <i class="fa fa-lock" aria-hidden="true"></i>
      <input matInput type="password" #pass1 [type]="visible ? 'text' : 'password'" required
        placeholder="{{'Multilang.password1' | translate}}" pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$"
        [(ngModel)]="password1" (change)="changeInput()" name="password1">
    </div>

    <div *ngIf="visible" class="visible-icon"><i class="fa fa-eye" aria-hidden="true" style="cursor: pointer"
      (click)="visible = !visible"></i></div>
  <div *ngIf="!visible" class="visible-icon"><i class="fa fa-eye-slash" aria-hidden="true"
      style="cursor: pointer" (click)="visible = !visible"></i></div>

    <!-- Password1 -->
    <div class="textbox mb-2">
      <i class="fa fa-lock" aria-hidden="true"></i>
      <input matInput #pass2 [type]="visible ? 'text' : 'password'" required
        placeholder="{{'Multilang.password2' | translate}}" pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$"
        [(ngModel)]="password2" (change)="changeInput()" name="password2">
    </div>


      </mat-card-content>
      <mat-card-actions fxLayout="row-reverse" fxflex="100%" fxLayoutGap="8px">
        <!-- <button mat-button type="submit" [disabled]="f.invalid">{{'Multilang.send' | translate}} <mat-icon>send
          </mat-icon></button>
        <button mat-button type="button" *ngIf="block === false" (click)="back()" color="primary">
          <mat-icon>arrow_back</mat-icon>{{'Multilang.backButton' | translate}}
        </button> -->
        <div class="container-fluid">
          <div class="row justify-content-between">
            <div class="col-7 pl-2">
              <!-- <a class="pl-2" routerLink="/reset-password" id="resetPasswordLink">{{'Multilang.resetPasswordButton' | translate}}</a> -->
            </div>
            <div class="col-3 px-0">
              <!-- il bottone -->
              <div class="spinner-container pl-2">
                <!-- Spinner -->
                <mat-spinner *ngIf="spinner" [diameter]="20"></mat-spinner>
              </div>
            </div>
          </div>
        </div>
      </mat-card-actions>
      <div class="container" style="text-align: center;">
        <div class="row">
          <div class="col-6">
            <a *ngIf="isBackButtonVisible" style="cursor: pointer;" (click)="back()" class="login-button">Indietro</a>
          </div>
          <div class="col-6">
            <button #buttonChange type="submit" [disabled]="f.invalid" [ngClass]="{
              'login-button': true,
              'login-button-active': !f.invalid,
              'login-button-disabled': f.invalid
            }">Invia</button>
          </div>
        </div>
      </div>
    </mat-card>
  </form>
</div>
<!-- Loading -->
<div class="loading-2" *ngIf="spinner">
</div>
